import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PagoCanceladoPage = () => {
  return (
    <div className="min-h-screen bg-background pt-24 pb-golden-2xl flex items-center justify-center">
      <div className="max-w-lg mx-auto px-golden-md text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="glass-card p-golden-2xl"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring" }}
            className="w-24 h-24 mx-auto mb-golden-lg rounded-full bg-yellow-500/20 flex items-center justify-center"
          >
            <XCircle className="w-12 h-12 text-yellow-500" />
          </motion.div>

          <h2 className="text-2xl mb-golden-md text-text-heading">
            Pago cancelado
          </h2>
          <p className="text-text-body mb-golden-md">
            Has cancelado el proceso de pago. No se ha realizado ningún cargo a tu cuenta.
          </p>
          <p className="text-text-muted text-sm mb-golden-xl">
            Si tienes alguna duda o necesitas ayuda, no dudes en contactarnos.
          </p>

          <div className="flex flex-col sm:flex-row gap-golden-md justify-center">
            <Link to="/precios" className="btn-primary inline-flex justify-center" data-testid="back-to-precios">
              <ArrowLeft className="w-5 h-5" />
              Volver a precios
            </Link>
            <Link to="/contacto" className="btn-secondary inline-flex justify-center" data-testid="contact-from-cancel">
              Contactar soporte
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PagoCanceladoPage;
